import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

export const cacheVersionInterceptor: HttpInterceptorFn = (req, next) => {
  const separator = req.url.includes('?') ? '&' : '?';
  const versionedUrl = `${req.url}${separator}_v=${environment.version}`;
  return next(req.clone({ url: versionedUrl }));
};
